import { Component, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { IHeaderParams } from '@ag-grid-community/core';
import { IHeaderAngularComp } from '@ag-grid-community/angular';
import { AgEvent, Column } from '@ag-grid-community/core';

interface CellValueChangedEvent extends AgEvent {
  data: any;
  column: Column;
  value: any;
}

@Component({
  selector: 'app-active-checkbox-header',
  template: `
    <div style="display: flex; align-items: center;">
      <mat-checkbox
        [checked]="checked"
        (change)="onCheckboxChange($event)">
      </mat-checkbox>
      <span style="margin-left: 8px;">{{ headerName }}</span>
    </div>
  `
})
export class ActiveCheckboxHeaderComponent implements IHeaderAngularComp, OnDestroy {
  public params: IHeaderParams;
  public checked = false;
  public headerName = '';

  constructor(private cdr: ChangeDetectorRef) {}

  private firstRenderHandler = () => this.updateHeaderCheckboxState();
  agInit(params: IHeaderParams): void {
    this.params = params;
    this.headerName = params.displayName || 'Active';

    this.params.api.addEventListener('cellValueChanged', this.onRowCheckboxChanged);

    this.params.api.addEventListener('firstDataRendered', this.firstRenderHandler);
    this.params.api.addEventListener('modelUpdated', this.firstRenderHandler); // fallback
  }

  ngOnDestroy(): void {
  this.params.api.removeEventListener('cellValueChanged', this.onRowCheckboxChanged);
  this.params.api.removeEventListener('firstDataRendered', this.firstRenderHandler);
  this.params.api.removeEventListener('modelUpdated', this.firstRenderHandler);
}


  refresh(params: IHeaderParams): boolean {
    return false;
  }

  onCheckboxChange(event: any): void {
    if (!this.params?.api) return;

    this.checked = event.checked;
    const columnId = this.params.column.getColId();

    this.params.api.forEachNode((rowNode) => {
      // Only apply to visible rows
      if (rowNode.data) {
        rowNode.setDataValue(columnId, this.checked);

        this.params.api.dispatchEvent({
          type: 'cellValueChanged',
          data: rowNode.data,
          column: this.params.column,
          value: this.checked
        } as CellValueChangedEvent);
      }
    });
  }

  onRowCheckboxChanged = (event?: any): void => {
    if (!this.params || !this.params.api) return;

    if (!event || event.column?.getColId() === this.params.column.getColId()) {
      this.updateHeaderCheckboxState();
    }
  };

  private updateHeaderCheckboxState(): void {
    if (!this.params || !this.params.api) return;

    const colId = this.params.column.getColId();
    let allChecked = true;

    this.params.api.forEachNode((rowNode) => {
      const value = rowNode.data?.[colId];
      if (!value) {
        allChecked = false;
      }
    });

    this.checked = allChecked;
    this.cdr.detectChanges();
  }
}
